import { useArrivalScanProcessor } from './useArrivalScanProcessor';
import { useArrivalHistory } from './useArrivalHistory';
import { useState, useRef, useCallback } from 'react';
import { useScannerFocus } from './useScannerFocus';

export const useArrivalScanning = () => {
  const [code, setCode] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  const { scannedItems, addScannedItem, clearScannedItems } =
    useArrivalHistory();

  const {
    handleScan: processCode,
    isLoading,
    lastResult,
    error,
    failedShippingNumber,
    showOverlay,
    setShowOverlay,
  } = useArrivalScanProcessor({
    onSuccess: (result) => {
      addScannedItem(result);
    },
  });

  useScannerFocus(inputRef, !showOverlay);

  const handleScan = useCallback(
    async (scannedCode: string) => {
      if (!scannedCode || isLoading) return;
      await processCode(scannedCode);
      setCode('');
      setTimeout(() => inputRef.current?.focus(), 50);
    },
    [processCode, isLoading]
  );

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleScan(code);
    }
  };

  return {
    code,
    setCode,
    onKeyDown,
    inputRef,
    handleScan,
    isLoading,
    lastResult,
    error,
    failedShippingNumber,
    scannedItems,
    clearScannedItems,
    showOverlay,
    setShowOverlay,
  };
};
